import Icon from '../components/Icon.vue'

Icon.register({
  'hand-point-down': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M91.8 467.2v-149.2c-8.2 5.8-16.6 10.6-24.9 14.2-31.8 13.6-66.9-9.9-66.9-44.1 0-18.6 10.9-32.2 29.1-40 28.3-12.1 64.3-78.6 77.3-107.5 8-17.9 25.5-28.5 43.8-28.5l0 0h171.5c11.8 0 21.9 8.6 23.7 20.3 7.3 46.8 38.5 61.8 38.3 123.7 0 2.7 0.2 13.3 0.2 16 0 50.7-22.1 81.6-71.3 72.6-9.3 18.6-39.5 30.7-62.3 16.5-21.2 24.6-53.9 22.6-70.9 6.3v99.9c0 24.1-20.2 44.8-43.8 44.8-23.3 0-43.8-21.3-43.8-44.8zM112 72v-48c0-13.3 10.7-24 24-24h192c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-192c-13.3 0-24-10.7-24-24zM324 48c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hand-point-down.js
// module id = 1431
// module chunks = 0